import React from 'react'
import ServicesCards from '../../components/ServicesCards/ServicesCards'

const Services = () => {
  return (
    <section>
        <ServicesCards/>
    </section>
  )
}

export default Services